<template>
    <a href="javascript:void(0)" v-on:click="openAeonPay" class="aeon-pay-app">
        <img src="/assets/images/icon/aeon-pay-logo.png" alt="" width="68">
    </a>
</template>
<script>
import Vue from 'vue';
import { DEEPLINK_AEONPAY_URL } from '../config/const';
import { Common } from '../common/common';

export default Vue.extend({
    name: 'Logo',
    methods: {
        openAeonPay() {
            Common.messageHandlers('show_browser', { url: DEEPLINK_AEONPAY_URL });
        }
    }
});
</script>

